import React from 'react';
import styles from './StarIcon.module.css';

/**
 * Star Icon Component
 * Displays colored star based on VIP level (bronze, silver, gold, platinum, diamond)
 */
const StarIcon = ({ color }) => {
  if (!color) return <span className={styles.dash}>--</span>;

  return (
    <div className={`${styles.star} ${styles[color]}`}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
    </div>
  );
};

export default StarIcon;
